import axios from 'axios';





// Axios 인스턴스 생성
const api = axios.create({

    // 백엔드 API 주소
    baseURL:
        '/api'
});





// =========================
// 로그인 API
// =========================

export const loginUser = (

    email: string,

    password: string

) => {

    return api.post(

        '/auth/login',

        {

            email,

            password
        }
    );
};





// =========================
// 회원가입 API
// =========================

export const signupUser = (

    email: string,

    password: string,

    nickname: string

) => {
    console.log('[sohn] signupUser attempt:', { email, nickname });
    return api.post(

        '/users/signup',

        {

            email,

            password,

            nickname
        }
    );
};





// =========================
// JWT 자동 추가
// =========================

api.interceptors.request.use(

    (config) => {

        // 저장된 토큰
        const token =

            localStorage.getItem(
                'token'
            );





        // 토큰 존재 시
        if(token) {

            config.headers.Authorization =

                `Bearer ${token}`;
        }





        return config;
    }
);





// =========================
// 로그인 처리
// =========================

export const handleLogin = async (

    email: string,

    password: string
) => {

    try {

        const response =

            await loginUser(

                email,

                password
            );





        // JWT 저장
        localStorage.setItem(

            'token',

            response.data.token
        );





        // 닉네임 저장
        localStorage.setItem(

            'nickname',

            response.data.nickname
        );





        // 권한 저장
        localStorage.setItem(

            'role',

            response.data.role
        );





        console.log(

            '로그인 성공'
        );





        console.log(

            response.data
        );





        return response.data;

    } catch (e) {

        console.error(e);

        throw e;
    }
};





// =========================
// 로그아웃
// =========================

export const logoutUser = () => {

    localStorage.removeItem(
        'token'
    );





    localStorage.removeItem(
        'nickname'
    );





    localStorage.removeItem(
        'role'
    );
};





// =========================
// 현재 로그인 유저
// =========================

export const getCurrentUser = () => {

    return {

        token:

            localStorage.getItem(
                'token'
            ),

        nickname:

            localStorage.getItem(
                'nickname'
            ),

        role:

            localStorage.getItem(
                'role'
            )
    };
};





// =========================
// 관리자 여부
// =========================

export const isAdmin = () => {

    return (

        localStorage.getItem(
            'role'
        ) === 'ADMIN'
    );
};





export default api;